const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const {BALogo} = require("./BALogo");
const withRenderSwitch = require("../hoc/withRenderSwitch");

const styles = require("./styles/LoadingCircle.css");

const NUM_CIRCLES = 12;
const ANIMATION_TIME = 1200;

// The server and client sometimes disagree on the last few digits of the
// percentage in the style of this component. We use this function to trim
// most of those digits off.
const roundFloat = function(x) {
	return Math.round(x * 1000) / 1000;
};

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withRenderSwitch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "LoadingCircle",

		propTypes: {
			colorType: PT.oneOf([
				"blue",
				"white",
				"cyan",
				"red",
				"yellow",
				"transparentGray",
				"color",
			]).isRequired,
			centerEl: PT.element,
			noCenter: PT.bool,
			centerImgSrc: PT.string,

			// Injected by HOCs
			isFirstRender: PT.bool.isRequired,
		},

		getDefaultProps: function() {
			return {
				colorType: "color",
			};
		},

		getInitialState: function() {
			return {
				globalCycle: Math.floor(
					global.performance ? global.performance.now() : Date.now()
				),
			};
		},

		render: function() {
			const globalCycle = this.props.isFirstRender ? 0 : this.state.globalCycle;
			const mainClass = this.props.isFirstRender
				? styles.mainHidden
				: styles.main;
			const circles = _.range(0, NUM_CIRCLES).map(i => {
				let circleClass = styles.c + " ";
				if (this.props.colorType === "color") {
					circleClass += i % 2 ? styles.blue : styles.red;
				} else {
					circleClass += styles[this.props.colorType];
				}
				const rawDelay = ANIMATION_TIME * (i / NUM_CIRCLES) - globalCycle;
				// Intentionally make delay negative to get the partially started behavior.
				const delay =
					((rawDelay % ANIMATION_TIME) - ANIMATION_TIME) % ANIMATION_TIME;
				const circleStyle = {
					left:
						roundFloat((Math.cos((Math.PI * 2 * i) / NUM_CIRCLES) + 1) * 50) +
						"%",
					top:
						roundFloat((Math.sin((Math.PI * 2 * i) / NUM_CIRCLES) + 1) * 50) +
						"%",
					animationDelay: delay + "ms",
					animationDuration: ANIMATION_TIME + "ms",
				};
				return (
					<div
						className={circleClass}
						style={circleStyle}
						key={"circle-" + i}
					/>
				);
			});
			let center = this.props.centerEl;
			if (this.props.noCenter) {
				center = null;
			} else if (!center) {
				center = (
					<BALogo className={styles.logo} colorType={this.props.colorType} />
				);
			}
			return (
				<div className={mainClass}>
					<div className={styles.container}>
						{circles}
						{center}
					</div>
				</div>
			);
		},
	})
);
